export default function MegaMenu(header, allMenus, closeAll, toggleMenu) {
	this.allMenus = allMenus;
	this.closeAll = closeAll;
	this.toggleMenu = toggleMenu;

	this.headerBottom = header.querySelector('.header-bottom-bar');
	this.megaMenuTriggers = this.headerBottom.querySelectorAll(
		'.main-header__desktop .menu > .menu-item-object-ccs_custom_menu_item'
	);

	this.megaEvents = () => {
		this.megaMenuTriggers.forEach((parent) => {
			parent.addEventListener('click', (e) => {
				this.toggleMenu(e);
			});
		});
	};

	this.events = () => {
		this.megaEvents();
	};

	return this;
}
